import { router } from 'expo-router';
import {
    BackButton,
    BackButtonIconType,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    FullScreenContainer,
    H2Emphasized,
    Image,
    isWeb,
    ScrollView,
    YStack,
} from 'smoothie';

import PaycheckRoutingInfo from '../../../../../assets/images/banking/paycheck-routing/paycheck-routing-info.png';

const PaycheckSplittingReady = () => {
    return (
        <FullScreenContainer
            header={
                <BackButton
                    fallbackRoute="/"
                    iconType={BackButtonIconType.LEFT}
                />
            }
            separator={true}
            footer={
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Continue"
                    onPress={() => {
                        router.navigate(
                            '/banking/paycheck-routing/account-detection',
                        );
                    }}
                />
            }
        >
            <ScrollView showsVerticalScrollIndicator={isWeb}>
                <YStack>
                    <Image
                        source={PaycheckRoutingInfo}
                        style={{
                            height: 290,
                            alignSelf: 'center',
                            aspectRatio: 'auto',
                            marginTop: 24,
                        }}
                        resizeMode="contain"
                    />
                    <YStack gap={12}>
                        <H2Emphasized>Auto-split your paycheck</H2Emphasized>
                        <BodyMediumRegular color="$gray1000">
                            Set up rules that direct every dollar to power your
                            lifestyle and goals. When income arrives, auto-split
                            it across accounts based on your priorities.
                        </BodyMediumRegular>
                    </YStack>
                </YStack>
            </ScrollView>
        </FullScreenContainer>
    );
};

export default PaycheckSplittingReady;
